import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 1A873476-B82D-4E23-BF19-897F0A0C0B93
 * name calendar-text
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-text.svg
 * tags
 * - Date / Time 
 */
export const CalendarTextIcon = createSvgIcon(<><path d="M14,14H7V16H14M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M17,10H7V12H17V10Z" /></>, 'CalendarTextIcon');
export default CalendarTextIcon